module.exports = __webpack_public_path__ + "static/img/precise-fertility.cc9ea39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/product/precise-fertility.jpg
// module id = XTot
// module chunks = 1